import { useState } from 'react';
import box from '~/assets/icons/box_4.svg';
import sort from '~/assets/icons/sort.svg';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { Text } from '~/components/ui/Text';
import { AppTruckJobActiveOrder } from '../AppTruckJobActiveOrder';
import { AppTruckJobOrderItem } from '../AppTruckJobOrderItem';
import { Select } from '../Select';
import { filterSelectItems } from './AppTruckJobAllOrders.model';
import {
	StyledContainer,
	StyledHeader,
	StyledHeadTitleContainer,
	StyledLeftContainer,
	StyledNotActiveOrderContainer,
	StyledOrdersContainer,
	StyledRightContainer,
} from './AppTruckJobAllOrders.styled';

const AppTruckJobAllOrders = () => {
	const [sortValue, setSortValue] = useState<string | number | null>(null);
	const activeOrder = true;

	return (
		<StyledContainer>
			<StyledLeftContainer>
				<StyledHeader>
					<StyledHeadTitleContainer>
						<img src={box} />
						<Text>Все заказы</Text>
					</StyledHeadTitleContainer>
					<Select
						icon={sort}
						items={filterSelectItems}
						value={sortValue}
						placeholder={'Сортировать'}
						onChange={(value) => setSortValue(value.value)}
						style={{ width: 240 }}
						dropdownHeight="210px"
					/>
				</StyledHeader>
				<ScrollContainer height={549} scrollbarHeight={529} showMask>
					<StyledOrdersContainer>
						<AppTruckJobOrderItem level={1} />
						<AppTruckJobOrderItem level={2} />
						<AppTruckJobOrderItem level={3} active />
						<AppTruckJobOrderItem level={4} />
						<AppTruckJobOrderItem level={5} />
						<AppTruckJobOrderItem level={1} />
						<AppTruckJobOrderItem level={2} />
						<AppTruckJobOrderItem level={3} />
						<AppTruckJobOrderItem level={4} />
						<AppTruckJobOrderItem level={5} />
						<AppTruckJobOrderItem level={1} />
						<AppTruckJobOrderItem level={2} />
						<AppTruckJobOrderItem level={3} />
						<AppTruckJobOrderItem level={4} />
						<AppTruckJobOrderItem level={5} />
					</StyledOrdersContainer>
				</ScrollContainer>
			</StyledLeftContainer>
			<StyledRightContainer>
				{activeOrder ? (
					<AppTruckJobActiveOrder />
				) : (
					<StyledNotActiveOrderContainer>
						<Text>
							Выберите один из доступных заказов
							<br />в списке слева
						</Text>
					</StyledNotActiveOrderContainer>
				)}
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { AppTruckJobAllOrders };
